import Swiper from "swiper";
// import { Navigation } from "swiper/modules";

// Post Slider Begin
const initQuotesSlider = () => {
  // Get all postSliders components instances
  const postsSliders = document.querySelectorAll(".quotes-slider");

  // Init slider and add events to each
  for (const postSlider of postsSliders) {
    const swiperControllers = postSlider.previousElementSibling;

    // const swpPrev = swiperControllers.querySelector(".swiper-prev");
    // const swpNext = swiperControllers.querySelector(".swiper-next");
    // const ownPagination = postSlider.querySelector(".swiper-pagination");

    swiperControllers;
    new Swiper(postSlider, {
      // configure Swiper to use modules
      // modules: [Navigation],
      loop: false,
      spaceBetween: 150,
      slidesPerView: 1,
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        // when window width is >= 640px
        768: {
          slidesPerView: 3,
        },
      },
      // If we need pagination
      //   pagination: {
      //     el: ownPagination,
      //     clickable: true,
      //   },
      // navigation: {
      //   nextEl: swpNext,
      //   prevEl: swpPrev,
      // },
    });
  }
};
initQuotesSlider();
